module.exports = __webpack_public_path__ + "img/marca5.7a8c29d3.jpg";